import { PAGE_BUILDER_PRICE_SELECTOR } from './constants';

export function getProductPath(container) {
    const directThemeTile = container.closest('.card, .listItem, .productCarousel-slide');

    if (directThemeTile) {
        const directLink = directThemeTile.querySelector('a[href]');

        if (!directLink) {
            return '';
        }

        try {
            return new URL(directLink.href, window.location.origin).pathname;
        } catch (error) {
            return '';
        }
    }

    let current = container.parentElement;

    while (current && current !== document.body) {
        const priceMatches = current.querySelectorAll(PAGE_BUILDER_PRICE_SELECTOR).length;
        const linkMatches = current.querySelectorAll('a[href]').length;

        if (priceMatches === 1 && linkMatches >= 1) {
            const productLink = current.querySelector('a[href]');

            if (!productLink) {
                return '';
            }

            try {
                return new URL(productLink.href, window.location.origin).pathname;
            } catch (error) {
                return '';
            }
        }

        current = current.parentElement;
    }

    return '';
}
